module.exports = __webpack_public_path__ + "static/media/aggregate_sl_init.c5e505eb.png";